"use client";
import { useGoogleTagManager } from "@/hooks/useGoogleTagManager";

export default function GlobalScripts() {
    // if (process.env.NODE_ENV === "development") return null;
    useGoogleTagManager();
    return null;
}
